import api from "../api";
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    orders: {},
    order: {},
    storeorders: {},
    storeorder: {},
    tags: {},
    paginate: {},
  },
  getters: {
    
  },
  actions: {
    async get_paginate_order({ commit }, payload = []) {
      try {
        api.post(`/v1/paginate-order`, payload)
          .then((res) => {
            commit("GET_PAGINATE_ORDER", res.data);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        console.log(e);
      }
    },

    async get_orders({ commit }) {
      try {
        api.get("/v1/orders")
          .then((res) => {
            commit("GET_ORDERS", res.data);
          })
          .catch((error) => {
            commit("ERROR_ORDER", "Erro ao carregar os pedidos");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ORDER", e);
      }
    },

    async get_order({ commit }, order_id) {
      try {
        api.get("/v1/orders/"+order_id)
          .then((res) => {
            commit("GET_ORDER", res.data);
          })
          .catch((error) => {
            commit("ERROR_ORDER", "Erro ao carregar os pedidos");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ORDER", e);
      }
    },

    async get_storeorders({ commit }, { store_id, bra_center, status }) {
      try {
        api.get("/v1/stores-orders/"+store_id+"?status="+status+"&bra_center="+bra_center)
          .then((res) => {
            commit("GET_STOREORDERS", res.data);
          })
          .catch((error) => {
            commit("ERROR_STOREORDER", "Erro ao carregar os pedidos");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STOREORDER", e);
      }
    },

    async get_storeorder({ commit }, id) {
      try {
        api.get("/v1/stores-order/"+id)
          .then((res) => {
            commit("GET_STOREORDER", res.data);
          })
          .catch((error) => {
            commit("ERROR_STOREORDER", "Erro ao carregar os pedidos");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STOREORDER", e);
      }
    },

    async invoice({ dispatch, commit }, payload = []) {
      try {
        
        return api.post("/v1/store-order-invoice", payload)
          .then((res) => {
            if(res?.data?.error){
              commit("ERROR_ORDER", res?.data?.error);
              //dispatch("alert/set_alert", {alert_message: res?.data?.message, type_message: 'alert-warning'}, { root: true });

              //if (window.innerWidth < 480) {
                toast.warning(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              //}

            }else{
              commit("GET_STOREORDER", res.data.result);
              //dispatch("alert/set_alert", {alert_message: res?.data?.message, type_message: 'alert-success'}, { root: true });
            
              //if (window.innerWidth < 480) {
                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              //}
            }  
            return res?.data?.error
          })
          .catch((error) => {
            console.log(error)
            //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });
          
            //if (window.innerWidth < 480) {
              toast.warning("Algo deu errado! Tente novamente mais tarde", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
            //}
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ORDER", e);
        //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });

        //if (window.innerWidth < 480) {
          toast.warning("Algo deu errado! Tente novamente mais tarde", {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
        //}
      }
    },

    async sendNF({ dispatch, commit }, payload = []) {
      try {
        
        api.post("/v1/store-order-send-nf", payload)
          .then((res) => {
            if(res?.data?.error){
              commit("ERROR_ORDER", res?.data?.error);
             
                toast.warning(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });

            }else{
              commit("GET_STOREORDER", res.data.result);
                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
            }  
            return res?.data?.error
          })
          .catch((error) => {
            console.log(error)
              toast.warning("Algo deu errado! Tente novamente mais tarde", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
          })
          .finally(() => (
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ORDER", e);
     
          toast.warning("Algo deu errado! Tente novamente mais tarde", {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
        //}
      }
    },

    async sendNFSefaz({ dispatch, commit }, payload = []) {
      try {
        
        api.post("/v1/send-nf-to-sefaz", payload)
          .then((res) => {
            if(res?.data?.error){
              commit("ERROR_ORDER", res?.data?.error);
             
                toast.warning(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });

            }else{
              commit("GET_STOREORDER", res.data.result);
                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
            }  
            return res?.data?.error
          })
          .catch((error) => {
            console.log(error)
              toast.warning("Algo deu errado! Tente novamente mais tarde", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
          })
          .finally(() => (
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ORDER", e);
     
          toast.warning("Algo deu errado! Tente novamente mais tarde", {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
        //}
      }
    },

    async getNF({ dispatch, commit }, payload = []) {
      try {
        // Espera pela requisição POST para continuar
        const res = await api.post("/v1/store-order-get-nf", payload);
    
        // Verifica a resposta
        if (res?.data?.error) {
          
          toast.warning(res?.data?.message, {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
        } else {
    
          toast.success(res?.data?.message, {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
        }
    
        // Retorna o valor para que possa ser utilizado no "then"
        return res?.data?.result?.data;
    
      } catch (error) {
        // Lida com erros
        console.log(error);    
        toast.warning("Algo deu errado! Tente novamente mais tarde", {
          type: 'default',
          theme: 'colored',
          hideProgressBar: true,
          dangerouslyHTMLString: true
        });
        
        // Retorna o erro para capturar no "then"
        return error;
      } finally {
        console.log('Requisição finalizada');
      }
    },

    async getShippingLabel({ dispatch, commit }, payload = []) {
      try {
        // Espera pela requisição POST para continuar
        const res = await api.post("/v1/get-shipping-label", payload);
    
        // Verifica a resposta
        if (res?.data?.error) {
          
          toast.warning(res?.data?.message, {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
        } else {
    
          toast.success(res?.data?.message, {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
        }
    
        // Retorna o valor para que possa ser utilizado no "then"
        return res?.data?.result?.data;
    
      } catch (error) {
        // Lida com erros
        console.log(error);    
        toast.warning("Algo deu errado! Tente novamente mais tarde", {
          type: 'default',
          theme: 'colored',
          hideProgressBar: true,
          dangerouslyHTMLString: true
        });
        
        // Retorna o erro para capturar no "then"
        return error;
      } finally {
        console.log('Requisição finalizada');
      }
    },

    async cancelOrder({ dispatch, commit }, payload = []) {
      try {
        
        return api.post("/v1/store-order-cancel", payload)
          .then((res) => {
            if(res?.data?.error){
              commit("ERROR_ORDER", res?.data?.error);
              //dispatch("alert/set_alert", {alert_message: res?.data?.message, type_message: 'alert-warning'}, { root: true });

              //if (window.innerWidth < 480) {
                toast.warning(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              //}

            }else{
              commit("GET_STOREORDER", res.data.result);
              //dispatch("alert/set_alert", {alert_message: res?.data?.message, type_message: 'alert-success'}, { root: true });
            
              //if (window.innerWidth < 480) {
                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              //}
            }  
            return res?.data?.error
          })
          .catch((error) => {
            console.log(error)
            //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });
          
            //if (window.innerWidth < 480) {
              toast.warning("Algo deu errado! Tente novamente mais tarde", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
            //}
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ORDER", e);
        //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });

        //if (window.innerWidth < 480) {
          toast.warning("Algo deu errado! Tente novamente mais tarde", {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
        //}
      }
    },

    async create_order_review({ dispatch, commit }, payload = []) {
      try {
        api.post("/v1/create-order-review/", payload)
          .then((res) => {
          
            dispatch("order/get_order", res?.data?.result?.order_id, { root: true });
            dispatch("alert/set_alert", {alert_message: res?.data?.message || "Criado com sucesso", type_message: 'alert-success'}, { root: true });

          })
          .catch((error) => {
            commit("ERROR_STORE", "Erro ao carregar: "+ error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STORE", e);
      }
    },

    async get_tags({ commit }) {
      try {
        api.get("/v1/tags")
          .then((res) => {
            commit("GET_TAGS", res.data);
          })
          .catch((error) => {
            commit("ERROR_ORDER", "Erro ao carregar os pedidos");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ORDER", e);
      }
    },

  },
  mutations: {
    GET_ORDERS(state, data) {
      state.orders = data
    },
    GET_ORDER(state, data) {
      state.order = data
    },
    ERROR_ORDER(state, data) {
      console.log(data)
    },
    GET_STOREORDERS(state, data) {
      state.storeorders = data
    },
    GET_STOREORDER(state, data) {
      state.storeorder = data
    },
    ERROR_STOREORDER(state, data) {
      console.log(data)
    },
    GET_TAGS(state, data) {
      state.tags = data
    },

    GET_PAGINATE_ORDER(state, data) {
      if (data?.paginate.current_page == 1) {
        state.orders = data?.products
      } else {
        state.orders.push(...data?.products)
      }
      state.paginate = data?.paginate
    },
  }
}